<mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Add Organization</h3>           
              <mat-icon (click)="close()" class="close" >close</mat-icon>            
          </div>
        </div>
    
          <div class="dialog_content">
           
              <form [formGroup]="addOrganizationForm" class="fix-mat-form-field">
      
                  <div fxLayout="row" fxLayoutAlign="start start">
                      <mat-form-field appearance="legacy" fxFlex>
                          <mat-label>Organization Name</mat-label>
                          <input matInput maxlength="30" placeholder="Organization Name" formControlName="organizatioName" #organizatioName>
                          <mat-error>
                            This field is required
                          </mat-error>
                      </mat-form-field>
                  </div>                 
                                      

                  <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" floatLabel="always" class="w-100-p">
                        <mat-label>Address1</mat-label>
                        <textarea matInput placeholder="Address 1" name="description" formControlName="address1" rows="3">
                        </textarea>
                        <mat-error>
                            This field is required
                          </mat-error>
                    </mat-form-field>
                  </div>
    
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" floatLabel="always" class="w-100-p">
                        <mat-label>Address2</mat-label>
                        <textarea matInput placeholder="Address 2" name="description" formControlName="address2" rows="3">
                        </textarea>
                        <mat-error>
                            This field is required
                          </mat-error>
                    </mat-form-field>
                  </div>
      
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field>
                        <mat-select placeholder = "Country List"  formControlName="countryId" 
                        (selectionChange)="getStateDropdownList($event)" [(ngModel)]="countrySelected" name = "countryId">
                        <input type="text" #searchCountry class="in" placeholder="Search Country" matInput autocomplete="off" (input)="onChangeCountry($event.target.value)" >
                        <mat-option *ngFor = "let country of countryList" 
                              [value] = "country.countryID">
                              {{country.countryName}}
                           </mat-option>
                        </mat-select>
                     </mat-form-field>
                     </div>
    
                     <div fxLayout="row" fxLayoutAlign="start start">
                        <mat-form-field>
                            <mat-select placeholder = "State List"  formControlName="stateId"
                            (selectionChange)="getCityDropdownList($event)" [(ngModel)]="stateSelected"
                             name = "stateId">
                             <input type="text" #searchState class="in" placeholder="Search State" matInput autocomplete="off" (input)="onChangeState($event.target.value)">
                               <mat-option *ngFor = "let state of stateList" 
                                  [value] = "state.stateID">
                                  {{state.stateName}}
                               </mat-option>
                            </mat-select>
                         </mat-form-field>
                         </div>
    
                         <div fxLayout="row" fxLayoutAlign="start start">
                            <mat-form-field>
                                <mat-select placeholder = "City List"
                                  formControlName="cityId" [(ngModel)]="citySelected"
                                 name = "cityId">
                                 <input type="text" #searchCity class="in" placeholder="Search City" matInput autocomplete="off" (input)="onChangeCity($event.target.value)">
                                   <mat-option *ngFor = "let city of cityList" 
                                      [value] = "city.cityID">
                                      {{city.cityName}}
                                   </mat-option>
                                </mat-select>
                             </mat-form-field>
                             </div>
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" fxFlex>
                        <mat-label>Zip Code</mat-label>                        
                        <input matInput placeholder="Zip Code" [(ngModel)]="zipCode"
                        (keyup)="checkValidatorLength()" maxlength="6" formControlName="zipCode" >
                        <mat-error>
                            This field is required
                          </mat-error>
                       
                        <mat-hint *ngIf="showErrorMessage == true" >
                            Please enter a valid Zip Code(3-6 digits)
                        </mat-hint>
                    </mat-form-field>
                </div>
      
                  <div fxLayout="row" fxLayoutAlign="start start">
                     
                          <mat-form-field class="example-full-width">
                              <mat-label>Telephone</mat-label>
                              <span matPrefix>+1 &nbsp;</span>
                              <input matInput placeholder="Phone" maxlength="10" formControlName="phoneNumber" mask="(000) 000-0000">
                             <mat-error>{{getPhoneErrorMessage()}}</mat-error>                            
                                  
                            </mat-form-field>
                  </div>
    
                  <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" fxFlex>
                        <mat-label>Email</mat-label>                     
                        
                        <input matInput maxlength="50" placeholder="Emailaddress" formControlName="email">
                        <mat-error>
                            {{ getErrorEmail() }}
                        </mat-error>
                    </mat-form-field>
                </div>
      
                  <div fxLayout="row" fxLayoutAlign="start start">
                      <mat-form-field class="choose" appearance="legacy" fxFlex>
                          <mat-label>Password</mat-label>
                          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password">
                              <mat-icon class="eye"  matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                              [attr.aria-pressed]="hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                              <mat-hint class="errorpass">Choose a password of at least eight characters with one uppercase
                                letter, one lowercase letter, one special character and one number
                            </mat-hint>
                          <mat-error class="errorpass" >
                              {{ getErrorPassword() }}
                          </mat-error>
                      </mat-form-field>
                  </div>
      
                  <div fxLayout="row" fxLayoutAlign="start start">
                      <mat-list-item role="listitem" class="fullw" >                        
                          <mat-form-field appearance="legacy" fxFlex class="rolesDropdown">
                              <mat-select placeholder="Organization Type" name="role"
                                  formControlName="organationType"  (selectionChange)="SelectionOrganationType($event)">
                                  <mat-option *ngFor="let org of organizationTypeList" [value]="org.id">
                                      {{org.name}}
                                  </mat-option>
                              </mat-select>
                              <mat-error>
                                This field is required
                              </mat-error>
                          </mat-form-field>
                      </mat-list-item>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start start" *ngIf="databaseNameShow">
                    <mat-form-field appearance="legacy" fxFlex>
                        <mat-label>Database Name</mat-label>
                        <input matInput placeholder="Database Name" formControlName="databaseName"
                        maxlength="30" (keypress)="checkDbName($event)">
                        <mat-error>
                          This field is required
                        </mat-error>
                    </mat-form-field>
                </div>
      
                  <div appearance="legacy" fxFlex>
                      <mat-checkbox formControlName="isActive" color="primary" (change)="CheckStatus($event)" 
                       [(ngModel)] = "isActiveChecked">Active</mat-checkbox>
                  </div>
              </form>
      
          </div>
    
    
    <div class="actionBtn">
    
    <button mat-flat-button class="cancel" (click)="close()" >Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" [disabled]="!addOrganizationForm.valid"
    (click)="addOrganization(addOrganizationForm.value)" color="primary">Create</button>
    </div>
    
    
</mat-card>

<div class="overlay" (click)="close()" ></div>
 

<app-loader></app-loader>
  